module.exports = __webpack_public_path__ + "images/1223abcbd9f0226a3474bd2847c9c455.svg";